// src/components/leadsComponents/ConnectGmailButton.js

import React, { useState } from 'react';
import request from '../../utils/request';

export default function ConnectGmailButton() {
  const [loading, setLoading] = useState(false);

  const handleConnect = async () => {
    setLoading(true);
    try {
      // 1) Ask your backend for the auth URL
      const { data } = await request.get('/hosts/oauth/url', {
        withCredentials: true
      });

      // 2) Do a full-page redirect to Google
      window.location.href = data.url;
    } catch (err) {
      console.error(err);
      setLoading(false);
      // optionally show an error toast here
    }
  };

  return (
    <button
      onClick={handleConnect}
      className="px-4 py-2 bg-[#2563EB] text-white rounded-[12px] disabled:opacity-50"
      disabled={loading}
    >
      {loading ? 'Finalizing…' : 'Connect Gmail'}
    </button>
  );
}
